import React from "react";
import CompanyWrapper from "../UserModule/user.style";
import PageTitle from "components/common/PageTitle";
import SubAdminCompanyFromAdminTable from "../../components/subadmincompanyModule/subadmincompanyFromAdminTable";
import { connect } from "react-redux";

const SubAdminCompanyFromAdmin = (props) => {
  // console.log(props);
  // console.log(props.match);
  // console.log(props.match.params.company_id);

  return (
    <CompanyWrapper {...props}>
      <div className="pos-relative">
        <PageTitle
          title="Company Sub Admin's"
          className="plr-15"
          iconClass="fas fa-building"
        />
        <div
          className="back-icon fs-15 demi-bold-text cursor-pointer"
          onClick={() => props.history.push("/companies")}
        >
          <i className="fas fa-step-backward"></i> Back
        </div>
      </div>
      <div className="user-tbl">
        <SubAdminCompanyFromAdminTable {...props} />
      </div>
    </CompanyWrapper>
  );
};

const mapStateToProps = (state) => {
  return {
    ...state.themeChanger,
  };
};

export default connect(mapStateToProps, null)(SubAdminCompanyFromAdmin);
